/**
 * MacroBank — owns a small fixed set of macros for a preset.
 *
 * A bank is the unit of "all macros visible in the rack". Four is
 * plenty of room for most patches without eating rack width. Callers
 * can still pass a custom count if they want more.
 */

import type { AudioEngine } from '../audio/AudioEngine';
import { Macro } from './Macro';

const DEFAULT_COUNT = 4;

export class MacroBank {
  readonly macros: readonly Macro[];

  constructor(count = DEFAULT_COUNT) {
    this.macros = Array.from({ length: count }, (_, i) => new Macro(i));
  }

  init(engine: AudioEngine): void {
    for (const m of this.macros) m.init(engine);
  }

  dispose(): void {
    for (const m of this.macros) m.dispose();
  }
}
